<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="900px"
  >
    <template v-slot:activator="{ on }">
      <v-btn
        icon 
        v-on="on"
      >
        <v-icon color="primary">
          mdi-clipboard-check
        </v-icon>
      </v-btn>
    </template>
    <material-card
      :offset="10"
      :full-width="true"
      color="hrissecondary"
      :title="position.name"
      text="Edit Position Approval Settings"
      class="mb-0"
    >
      <form v-if="dialog">
        <v-container>
          <v-row>
            <v-col cols="12">
              <setup-job-position-job-title-leave-container-view
                :position="position"
                @close-dialog="closeDialog"
              />
            </v-col>
          </v-row>
        </v-container>
      </form>
    </material-card>
  </v-dialog>
</template>

<script>
  export default {
    components: {
      SetupJobPositionJobTitleLeaveContainerView: () => import('@/components/hris/setup/job-position/job-title/LeaveContainerView'),
    },
    props: {
      position: { 
        type: Object,
        required: true,
      },
    },
    data () {
      return {
        dialog: null,
        progressing: false,
        leaveTypes: [],
      }
    },
    watch: {
      dialog: function (value) {
       
      },
    },
    methods: {
      closeDialog () {
        this.dialog = false
      },
      
    },
  }
</script>
